export const TESTIDS = {
  // Landing
  landingHero: "landing-hero",
  landingPropertyName: "landing-property-name-input",
  landingCity: "landing-city-input",
  landingState: "landing-state-input",
  landingCountry: "landing-country-input",
  landingWebsite: "landing-website-input",
  landingSubmit: "landing-grade-my-hotel-btn",
  landingSample: "landing-load-sample-btn",
  // Grading
  gradingProgressBar: "grading-progress-bar",
  gradingStageLabel: "grading-stage-label",
  gradingPlatformCol: (p) => `grading-platform-${p}`,
  // Report Tier 1
  reportScoreValue: "report-score-value",
  reportScoreBand: "report-score-band",
  reportPeerBenchmark: "report-peer-benchmark",
  reportWonExample: "report-won-example",
  reportLostExample: "report-lost-example",
  reportDramaticStat: "report-dramatic-stat",
  reportTopicalClusters: "report-topical-clusters",
  emailGateEmail: "email-gate-email-input",
  emailGateFirstName: "email-gate-first-name-input",
  emailGateLastName: "email-gate-last-name-input",
  emailGateJobTitle: "email-gate-job-title-input",
  emailGateCompany: "email-gate-company-input",
  emailGateSubmit: "email-gate-unlock-btn",
  // Report Tier 2
  reportTier2Section: "report-tier2-section",
  subScoreCard: (k) => `sub-score-card-${k}`,
  evidenceTable: "evidence-table",
  evidenceRow: (i) => `evidence-row-${i}`,
  effortImpactMatrix: "effort-impact-matrix",
  recommendationCard: (i) => `recommendation-card-${i}`,
  // Score-Lift Dashboard (post-recurring-run)
  liftDashboardSection: "lift-dashboard-section",
  liftDashboardTrendline: "lift-dashboard-trendline",
  liftDashboardTotalLift: "lift-dashboard-total-lift",
  liftDashboardPublishedCount: "lift-dashboard-published-count",
  liftDashboardAssignedCount: "lift-dashboard-assigned-count",
  liftDashboardOpenCount: "lift-dashboard-open-count",
  liftDashboardLastPublished: "lift-dashboard-last-published",
  // Admin
  adminTokenInput: "admin-token-input",
  adminSignInBtn: "admin-sign-in-btn",
  adminAnalysesTable: "admin-analyses-table",
  // First Move + Draft
  firstMoveCard: "first-move-card",
  firstMoveDraftBtn: "first-move-draft-btn",
  restOfPlanToggle: "rest-of-plan-toggle",
  evidenceToggle: "evidence-toggle",
  draftEditor: "draft-editor",
  draftTitle: "draft-title",
  draftBlock: (i) => `draft-block-${i}`,
  draftGhostPrompt: (i) => `draft-ghost-prompt-${i}`,
  draftGhostFill: (i) => `draft-ghost-fill-${i}`,
  draftRewriteBtn: (i) => `draft-rewrite-btn-${i}`,
  draftFirsthandCounter: "draft-firsthand-counter",
  draftPublishBtn: "draft-publish-btn",
  trialSignupEmail: "trial-signup-email",
  trialSignupSubmit: "trial-signup-submit",
};
